<script lang="ts">
  import ControlBar from '../ControlBar.svelte'
  import PlayPauseButton from '../buttons/PlayPauseButton.svelte'
  import SeekBackwardButton from '../buttons/SeekBackwardButton.svelte'
  import SeekForwardButton from '../buttons/SeekForwardButton.svelte'
  import VolumeButton from '../buttons/VolumeButton.svelte'
  import AirPlayButton from '../buttons/AirPlayButton.svelte'
  import ChromecastButton from '../buttons/ChromecastButton.svelte'
  import SettingsButton from '../buttons/SettingsButton.svelte'
  import CaptionsButton from '../buttons/CaptionsButton.svelte'
  import FullscreenButton from '../buttons/FullscreenButton.svelte'
  import PiPButton from '../buttons/PiPButton.svelte'
  import LiveIndicator from './LiveIndicator.svelte'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from '../buttons/ControlBarButton.svelte'
</script>

<ControlBar>
  {#snippet left()}
    <PlayPauseButton
      tooltipPosition={CONTROL_BAR_BUTTON_TOOLTIP_POSITION.LEFT}
    />
    <SeekBackwardButton />
    <SeekForwardButton />
    <VolumeButton />
  {/snippet}
  {#snippet right()}
    <AirPlayButton />
    <ChromecastButton />
    <SettingsButton />
    <CaptionsButton />
    <FullscreenButton />
    <PiPButton />
    <LiveIndicator />
  {/snippet}
</ControlBar>
